export const BLOG_POSTS = [
  {
    id: "ai-and-the-rise-of-the-empowered-individual",
    title: "AI and the Rise of the Empowered Individual",
    cat: "Technology",
    img: "cjmeister-com-_DSC5184.jpg",
    date: "JUN 23, 2026",
    read: "12 MIN READ",
    short: "12 MIN",
    blurb:
      "Why AI may disproportionately benefit generalists — and why trust could become the scarcest resource of all.",
    kw: "ai product technology generalist trust information",
    featured: true,
  },
  {
    id: "risk-calculation-for-lending-is-there-a-simpler-way",
    title: "Risk Calculation for Lending: Is there a simpler way?",
    cat: "Technology",
    img: "lending-risk-cover.jpg",
    date: "JAN 16, 2020",
    read: "8 MIN READ",
    short: "8 MIN",
    blurb:
      "Affordability and trust — not thousands of proxy data points. Why Open Banking could replace the arbitrary risk models of mobile lending's early days.",
    kw: "fintech lending open-banking risk credit data product",
  },
  {
    id: "the-scientific-art-of-product-management",
    title: "The (scientific) art of product management",
    cat: "Technology",
    img: "scientific-art-pm-cover.jpg",
    date: "JAN 3, 2020",
    read: "10 MIN READ",
    short: "10 MIN",
    blurb:
      "Product management is a scientific discipline — but there is an art to creating something people will love. On data, vision, and the Nokia lesson.",
    kw: "product product-management data vision nokia customer-feedback",
  },
];
